const record = (v) => typeof v === 'object' && v !== null;
const strings = (v, keys) => keys.every((k) => typeof v[k] === 'string');
const optional = (v) => v === null || typeof v === 'string';
const envelope = (v, org) => record(v) &&
    v.schemaVersion === 1 &&
    v.testOnly === true &&
    v.organizationId === org &&
    Array.isArray(v.items);
const act = (v, org) => record(v) &&
    v.organizationId === org &&
    strings(v, ['id', 'number', 'date', 'subject', 'resolutions', 'effectiveFrom']) &&
    optional(v.effectiveTo) &&
    optional(v.deletedAt) &&
    ['general_assembly', 'administration_council', 'surveillance_council'].includes(String(v.organ)) &&
    ['ordinary', 'extraordinary', 'informative'].includes(String(v.sessionType)) &&
    Number.isInteger(v.version) &&
    Number(v.version) > 0 &&
    ['pending', 'approved'].includes(String(v.documentStatus)) &&
    typeof v.hasDocument === 'boolean';
const rule = (v, org) => record(v) &&
    v.organizationId === org &&
    strings(v, [
        'id',
        'code',
        'lineageId',
        'conceptId',
        'conceptName',
        'actId',
        'actNumber',
        'amount',
        'periodicity',
        'effectiveFrom',
        'condition',
    ]) &&
    /^\d+\.\d{2}$/.test(String(v.amount)) &&
    optional(v.effectiveTo) &&
    optional(v.deletedAt) &&
    optional(v.lifecycleReason) &&
    Number.isInteger(v.versionNumber) &&
    Number(v.versionNumber) > 0 &&
    typeof v.isCurrent === 'boolean';
export function isInstitutionalActs(v, org) {
    return envelope(v, org) && v.items.every((i) => act(i, org));
}
export function isInstitutionalRules(v, org) {
    return envelope(v, org) && v.items.every((i) => rule(i, org));
}
